import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { AffiliateData } from "../types/AffiliateData";

//TODO : implement authorization
const affilaitesRef = collection(db, "affiliates");
const settingsRef = collection(db, "settings");
export const getAffiliateMap = async () => {
  const docSnap = await getDocs(affilaitesRef);
  let affiliates = new Map<string, AffiliateData>();

  for (const item of docSnap.docs) {
    if (item.exists()) {
      let affiliate = item.data() as AffiliateData;
      affiliates.set(affiliate.address, affiliate);
    }
  }
  return affiliates;
};

export const setAffiliate = async (address: string, note: string) => {
  await setDoc(doc(affilaitesRef, address), {
    address: address,
    note: note,
  });
};

export const getSettings = async () => {
  let defaultSettings = await getDoc(doc(settingsRef, "default"));
  return defaultSettings.data();
};

export const setReferralCodeRequired = async (required: boolean) => {
  let defaultSettings = doc(settingsRef, "default");

  await setDoc(defaultSettings, {
    referralCodeRequired: required,
  });
};
